/* 🤖 this file was generated by svg-to-ts */
export const matIconMms: {
  name: 'mms';
  data: string;
} = {
  name: 'mms',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-5.5-8L11 12.51 8.5 9.5 5 14h14z"/></svg>`
};
